
export const state =  {
    incident         : null,
    components       : null,
    incidenttypes    : null,
    forwardings      : null,
    deliverytimes    : null,
    costtypes        : null,
    manufacturer     : null,
    zuescompanies    : null,
    assessmentresults: null,
    assessmenttypes  : null,
    stepdatahistory     : null,
    assessmentfaulttypes: null,
    bidReason           : null,
    clipboard           : null,
    todo                : {
        allCustomer     : false,
        selectedCustomer: null,
        visible         : null,
        search          : null
    },
}